
export default {
    name: "banner-card",
    props: {
        item: {
            type: Object,
        },
        idx: {
            type: Number,
        },
        pa_page_name: {
            type: String,
        }
    },
    computed: {
        model_id() {
            return this.$store.state.tag.all_site_model_id;
        },
        route_name() {
            return this.$route;
        },
    },

    methods: {
        paFunction(idx) {
            let reg_link = this.item.link.replace('https://', 'http://');
            let pa_idx = 1 + idx/10000;
            window._piq.push(['trackEvent', `rs2022::十大頻道::${this.pa_page_name}`, `click::大輪播圖::article_carousel::${this.model_id}`, `大輪播圖::${reg_link}`, pa_idx]);
        }
    },
    mounted() {
    }
}
